import {
  IonAlert,useIonViewDidEnter,IonCard,IonCardContent,IonCol,IonContent,IonHeader,IonLabel,IonPage,IonRow,IonTitle,IonToolbar,
  useIonViewWillEnter,useIonViewDidLeave,useIonViewWillLeave,useIonLoading,IonIcon,IonItem,
  IonModal,  IonButtons, IonButton
} from "@ionic/react";

import React, { useState } from "react";
import * as API from "../utils/api";
import * as apiConstants from "../constants/api-endpoint";
import { CustomerDetail } from "../interface/customerDetails.i";
import { chevronBackSharp,locate } from 'ionicons/icons';
import { useHistory } from "react-router";
import styled from "styled-components";
import moment from 'moment';
import Swal from 'sweetalert2';
import { Linking } from "react-native";
import LogoutPage from "./Logout";
import NumberFormat from 'react-number-format';
import './Page.css';
import { Link } from "react-router-dom";
import DrawCanvas from "./../components/DrawingCanvas/DrawingCanvas";

  const UpcomingShedulePage: React.FC = (props : any) => {
  console.log("url of page",props.location);
  let urlloc = props.location.search;
  if(props?.location?.search){
  // let spurl = urlloc.split('=');
  // setLoc(spurl);
  setLoc = (urlloc.split('=').slice(1));
  console.log("split url is",setLoc);
  }
 
  const gotoInspectionPage = (user: CustomerDetail) => {
    //To goto inspection page
    history.push("/inspection-page", { userData: user  });
  }

  const gotoServiceProgramPage = (user: CustomerDetail) => {
    //To goto service program page
    history.push("/service-program-page", { userData: user  });
  }

  const gotoSiteSurveyPage = (user: CustomerDetail) => {
    //To goto site survey page
    history.push("/site-survey-page", { userData: user  });
  }

  const gotoPumpOutPage = (user: CustomerDetail) => {
    //To goto pumpout page
    history.push("/pump-out-page", { userData: user  });
  }
  
  const [present] = useIonLoading();
  const [issuccess, setIssuccess] = useState<boolean>(false);
  const [iserror, setIserror] = useState<boolean>(false);
  const [message, setMessage] = useState<string>();
  const [payload, setPayload] = useState<any[]>([]);
  const [disable, setDisable] = React.useState(false);
  const [isOpen, setIsOpen] = useState(false);
  var [loc, setLoc] = useState<string>();
  // setLoc(spurl);
  // console.log("split url is",spurl);
  let data = [] as CustomerDetail[];
  const history = useHistory();
  const gotoBack = () => {
      history.push("/dashboard");
  }

  const getData = () => {
    //To display data of schedule page
    present("Please wait...", 2000);
    if(props.location.search == '?selection=inspectionschedule') {
    API.authGetRequest(apiConstants.gelAllInspections, "")
      .then((res) => {
        data = res.data;
        setPayload(data);
        payload.push(data);
      })
      .catch((error) => {
        setMessage("Something went wrong!!!try again");
        setIserror(true);
      });
    } else if(props.location.search == '?selection=serviceprogramschedule') {
      API.authGetRequest(apiConstants.serviceProgram + localStorage.username, "")
        .then((res) => {
          data = res.data;
          setPayload(data);
          payload.push(data);
        })
        .catch((error) => {
          setMessage("Something went wrong!!!try again");
          setIserror(true);
        });
     } else if(props.location.search == '?selection=serviceprogramtechnicalonboardingschedule') {
      API.authGetRequest(apiConstants.serviceProgramTechnicalOnboarding, "")
        .then((res) => {
          data = res.data;
          setPayload(data);
          payload.push(data);
        })
        .catch((error) => {
          setMessage("Something went wrong!!!try again");
          setIserror(true);
        });
     } else if(props.location.search == '?selection=pumpoutschedule') {
      API.authGetRequest(apiConstants.pumpOutSchedule + localStorage.username, "")
        .then((res) => {
          data = res.data;
          setPayload(data);
          payload.push(data);
        })
        .catch((error) => {
          setMessage("Something went wrong!!!try again");
          setIserror(true);
        });
     }
  };

  useIonViewWillEnter(() => {
    console.log("ionViewWillEnter event fired");
    API.authGetRequest(apiConstants.gelAllInspections, "")
      .then((res) => {
        console.log("allIns===", res);
      })
      .catch((error) => {
        setMessage("Auth failure! Please create an account");
        setIserror(true);
      });
  });

  useIonViewDidEnter(async () => {
    await console.log("IonViewDidEnter- vendor");
  });

  useIonViewWillLeave(() => {
    console.log("IonViewWillLeave -vendor");
  });

  useIonViewDidLeave(() => {
    console.log("IonViewDidLeave -vendor");
  });

  const naviagteToMap = (address: string) => {
    //To navigate map based on property location
    const url = apiConstants.locationUrl+address;
    Linking.canOpenURL(url).then(supported => {
      if (supported) {
        Linking.openURL(url);
      } else {
        console.log('Don\'t know how to open URI: ' + url);
      }
    });
  }

  const signout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("username");
    localStorage.clear();
    history.push("/Login");
}


  const NotifyButton =(id:number) => {
    //To notify customers before doing service and site survey
    if(props.location.search == '?selection=serviceprogramschedule') {
    const name = localStorage.username;
    const notified = apiConstants.notify + id + '/' + name;
    API.authGetRequest(notified, '')
      .then((res) => {
        const responseData = res.data
        Swal.fire({
          title: "Success!",
          text: responseData.message,
          icon : "success"
       }).then(OK => {
        API.authGetRequest(apiConstants.serviceProgram + localStorage.username, "")
      .then((res) => {
        data = res.data;
        setPayload(data);
        payload.push(data);
      })
    });
  })
} else if(props.location.search == '?selection=serviceprogramtechnicalonboardingschedule') {
    const name = localStorage.username;
    const notified = apiConstants.notifySiteSurvey + id + '/' + name;
    API.authGetRequest(notified, '')
      .then((res) => {
        const responseData = res.data
        Swal.fire({
          title: "Success!",
          text: responseData.message,
          icon : "success"
       }).then(OK => {
        API.authGetRequest(apiConstants.serviceProgramTechnicalOnboarding, "")
      .then((res) => {
        data = res.data;
        setPayload(data);
        payload.push(data);
      })
    });
  })
} else if(props.location.search == '?selection=pumpoutschedule') {
  const name = localStorage.username;
  const notified = apiConstants.notifyPumpOut + id + '/' + name;
  API.authGetRequest(notified, '')
    .then((res) => {
      const responseData = res.data
      Swal.fire({
        title: "Success!",
        text: responseData.message,
        icon : "success"
     }).then(OK => {
      API.authGetRequest(apiConstants.pumpOutSchedule + localStorage.username, "")
    .then((res) => {
      data = res.data;
      setPayload(data);
      payload.push(data);
    })
  });
})
}
}
  

  return (
    
    <SchedulePage>
    <IonPage onLoad={getData}>
      <IonHeader>
        <IonToolbar>
          <IonRow >
          <IonCol size="4" >
          <IonItem lines="none" onClick={gotoBack} >
              <IonIcon color = "primary" slot="start" icon={chevronBackSharp} style={{fontSize : "40px", paddingTop: "10px"}} />
              </IonItem>
            </IonCol>
         
            <IonCol className="ion-align-self-center" style={{ textAlign: "justify" }}>
            <img src="assets/logo001.png" width="40%" />
            </IonCol>

            <LogoutPage/>

          </IonRow>
        </IonToolbar>

        <IonToolbar color="secondary">
    
        <IonTitle>Powered By:<span><b>Septic Smart</b></span></IonTitle>
        
      </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonRow>
          <IonCol>
            <IonAlert
              isOpen={iserror}
              onDidDismiss={() => setIserror(false)}
              cssClass="my-custom-class"
              message={message}
              buttons={["Dismiss"]}
            />
            <IonAlert
              isOpen={issuccess}
              onDidDismiss={() => setIssuccess(false)}
              cssClass="my-custom-class"
              message={message}
              buttons={["Ok"]}
            />
          </IonCol>
        </IonRow>
        <>
          {payload.map((user, index) => (
            // <p className="user">{user.id}</p>
            <IonCard key={index} style={{ borderLeft: "10px solid #53A658" }}>
               {props.location.search == '?selection=inspectionschedule' ?
              <IonCardContent className="card_content">
              <IonRow>
                <IonCol size="4">
                  <IonLabel className="ion-text-wrap">
                    Customer Name:{user.ownersName}
                  </IonLabel>
                </IonCol> 
                <IonCol size="4">
                <IonLabel className="ion-text-wrap">
                    Municipality:{user.municipalityName}
                  </IonLabel>
                </IonCol>

                <IonCol size="4">
                <IonLabel className="ion-text-wrap">
                    Zipcode:{user.propertyZip}
                  </IonLabel>
                </IonCol>
              </IonRow>
                
                <IonRow>
                   <IonCol size="4">
                  <IonLabel className="ion-text-wrap">
                    Telephone: {user.phone}
                  </IonLabel>
                </IonCol>
              
                

                <IonCol size="4">
                <IonLabel className="ion-text-wrap">
                    Location:{user.propertyLocation}
                  </IonLabel>
                </IonCol>
                <IonCol size="4">
                  <IonLabel className="ion-text-wrap">                 
                    Service Route:{user.uspsPropertyCarrierRoute}
                  </IonLabel>
                </IonCol>
               
                </IonRow>

                <IonRow>
                <IonCol size="4">
                <IonLabel className="ion-text-wrap">
                    Date:{moment(user.inspectionDate).format('MM/DD/YYYY')}
                  </IonLabel>
                </IonCol>
              
                <IonCol size="4">
                <IonLabel className="ion-text-wrap">
                    City: {user.propertyCity}
                  </IonLabel>
                </IonCol>
                <IonCol size="4">
                   <button type="button" className="ion-button" onClick={() => {gotoInspectionPage(user)}}>Inspect</button>
                <IonIcon className="ion-gps" icon={locate} onClick={() => naviagteToMap(user.propertyLocation +' '+user.propertyCity)}/>
                <IonCol size = "4">
                  {/* Canvas Tool Start */}
                  <button type="button" className="ion-button" onClick={() => setIsOpen(true)}>Draw Canvas</button>
                  <IonModal isOpen={isOpen}>
                    <IonHeader>
                      <IonToolbar color="secondary">
                        <IonTitle>Draw Canvas</IonTitle>
                        <IonButtons slot="end">
                          <IonButton onClick={() => setIsOpen(false)}>Close</IonButton>
                        </IonButtons>
                      </IonToolbar>
                    </IonHeader>
                    <IonContent className="ion-padding">
                      <DrawCanvas></DrawCanvas>
                    </IonContent>
                  </IonModal>
                {/* Canvas Tool end */}
                </IonCol>
                
                <IonCol size = "4">
                </IonCol> 
                </IonCol>
              </IonRow>
              
              </IonCardContent>
              : null}
               
               {props.location.search == '?selection=serviceprogramschedule' ?
              <IonCardContent className="card_content">
              <IonRow>
                <IonCol size="4">
                  <IonLabel className="ion-text-wrap">
                    Customer Name:{user.ownersName}
                  </IonLabel>
                </IonCol>
                <IonCol size="4">
                  <IonLabel className="ion-text-wrap">
                    Location:{user.propertyLocation}
                  </IonLabel>
                </IonCol>

                <IonCol size="4">
                  <IonLabel className="ion-text-wrap">
                    Service Date:{moment(user.serviceDate).format('MM/DD/YYYY')}
                  </IonLabel>
                </IonCol>
              </IonRow>
                
                <IonRow>
                   <IonCol size="4">
                  <IonLabel className="ion-text-wrap">
                  {(() => {
                    if(user.cellPhone != null){
                      return ( 
                        <IonLabel>
                        Telephone:  <NumberFormat value={user.cellPhone} displayType={'text'} format="(###) ###-####" />
                        </IonLabel>
                        )
                      }
                      else if(user.cellPhone == null){
                        return ( 
                          <IonLabel>
                          Telephone:  <NumberFormat value={user.workPhone || user.homePhone} displayType={'text'} format="(###) ###-####" />
                          </IonLabel>
                          )
                        }
                      else if(user.homePhone == null){
                          return ( 
                            <IonLabel>
                            Telephone:  <NumberFormat value={user.workPhone || user.cellPhone} displayType={'text'} format="(###) ###-####" />
                            </IonLabel>
                            )
                          }
                      else if(user.workPhone == null){
                            return ( 
                              <IonLabel>
                              Telephone:  <NumberFormat value={user.homePhone || user.cellPhone} displayType={'text'} format="(###) ###-####" />
                              </IonLabel>
                              )
                            }
                    })()} 

                    {(() => {
                      if(user.cellPhone === null && user.homePhone == null && user.workPhone == null){
                        return ( 
                          <IonLabel>
                            <IonLabel>N/A</IonLabel>
                          </IonLabel>
                          )
                        }
                      })()}  
                  </IonLabel>
                </IonCol>
              
                

                <IonCol size="4">
                  <IonLabel className="ion-text-wrap">
                    City: {user.propertyCity}
                  </IonLabel>
                </IonCol>
                <IonCol size="4">
                  {/* <IonLabel className="ion-text-wrap">
                    System Type: {user.systemType}
                  </IonLabel> */}

                  {(() => {
                    if(user.serviceProgramType.includes('Peat') || user.serviceProgramType.includes('HOOT') || user.serviceProgramType.includes('Aerobic')){
                      return ( 
                        <IonLabel>
                        System Type: ATU
                        </IonLabel>
                        )
                      } else {
                        return ( 
                          <IonLabel>
                         System Type: Conventional
                          </IonLabel>
                          )
                      }
                    })()} 
                </IonCol>
                </IonRow>

                <IonRow>
                <IonCol size="4">
                  Municipality: {user.municipalityName}
                </IonCol>
              
                <IonCol size="4">
                  <IonLabel className="ion-text-wrap">
                    Zip code: {user.propertyZip}
                  </IonLabel>
                </IonCol>

                <IonCol size="4">
                  <IonLabel className="ion-text-wrap">
                    {/* Service Type: {user.serviceProgramType.replace('HOOT','Aerobic')} */}

                    {(() => {
                    if((user.serviceNumber == 1 || user.serviceNumber == 3) && user.spQuarterly == 'Yes'){
                      return ( 
                        <IonLabel>
                        Service Type: Filter Cleaning
                        </IonLabel>
                        )
                      } else {
                        return ( 
                          <IonLabel>
                          Service Type: {user.serviceProgramType.replace('HOOT','Aerobic')}
                          </IonLabel>
                          )
                      }
                    })()} 
                  </IonLabel>
                </IonCol>
                </IonRow>
                
                <IonRow>
                <IonCol size="4">
                <IonLabel className="ion-text-wrap">
                {(() => {
                    if(user.additionalService != null){
                      return ( 
                        <IonLabel>
                        Additional Service: {user.additionalService}
                        </IonLabel>
                        )
                      }
                    })()} 
                    
                    {(() => {
                      if(user.additionalService === ''){
                        return ( 
                          <IonLabel>
                            <IonLabel>N/A</IonLabel>
                          </IonLabel>
                          )
                        }
                      })()}

                      {(() => {
                      if(user.additionalService == null){
                        return ( 
                          <IonLabel>
                            <IonLabel>Additional Service: N/A</IonLabel>
                          </IonLabel>
                          )
                        }
                      })()}  
                   </IonLabel>
                </IonCol>


                <IonCol size="4">
                <IonLabel className="ion-text-wrap">
                {(() => {
                    if(user.spSemiAnnual !=null && user.spSemiAnnual.toUpperCase() == 'YES'){
                      return ( 
                        <IonLabel>
                        Service Number: {user.serviceNumber + ' of 2'}
                        </IonLabel>
                        )
                      } else if(user.spQuarterly !=null && user.spQuarterly.toUpperCase() == 'YES'){
                        return ( 
                          <IonLabel>
                          Service Number: {user.serviceNumber + ' of 4'}
                          </IonLabel>
                          )
                        }
                    })()} 
                  </IonLabel>
                </IonCol>

                <IonCol size="4">
                <IonLabel className="ion-text-wrap">
                {(() => {
                    if(user.specialNotes != null){
                      return ( 
                        <IonLabel>
                        Special Notes: {user.specialNotes}
                        </IonLabel>
                        )
                      } else if(user.specialNotes == null){
                        return ( 
                          <IonLabel>
                         Special Notes: N/A
                          </IonLabel>
                          )
                        }
                    })()} 
                  </IonLabel>
                </IonCol>
                </IonRow>
                
                <IonRow>
                 <IonCol/> <IonCol/>
                <IonCol>
                   <button type="button" className="ion-button" onClick={() => {gotoServiceProgramPage(user)}}>Service</button>
                <IonIcon className="ion-gps" icon={locate} onClick={() => naviagteToMap(user.propertyLocation +' '+user.propertyCity)}/>
                  {(() => {
                    if(user.notified === "No"){
                      return ( 
                        <IonCol>
                        <button type="button" className="ion-button" onClick={() => NotifyButton(user.id)}>Notify</button>
                        </IonCol>
                        )
                      }
                    })()} 
                </IonCol>
              </IonRow>
              
              </IonCardContent>
              : null}

{props.location.search == '?selection=serviceprogramtechnicalonboardingschedule' ?
              <IonCardContent className="card_content">
              <IonRow>
                <IonCol size="4">
                  <IonLabel className="ion-text-wrap">
                    Customer Name: {user.ownersName}
                  </IonLabel>
                </IonCol>

                <IonCol size="4">
                  Municipality: {user.municipalityName}
                </IonCol>

                <IonCol size="4">
                  <IonLabel className="ion-text-wrap">
                   Service Route: {user.uspsPropertyCarrierRoute}
                  </IonLabel>
                 </IonCol>
                </IonRow>

                <IonRow>
                <IonCol size="4">
                  <IonLabel className="ion-text-wrap">
                  {(() => {
                    if(user.cellPhone != null){
                      return ( 
                        <IonLabel>
                        Telephone:  <NumberFormat value={user.cellPhone} displayType={'text'} format="(###) ###-####" />
                        </IonLabel>
                        )
                      }
                      else if(user.cellPhone == null){
                        return ( 
                          <IonLabel>
                          Telephone:  <NumberFormat value={user.workPhone || user.homePhone} displayType={'text'} format="(###) ###-####" />
                          </IonLabel>
                          )
                        }
                      else if(user.homePhone == null){
                          return ( 
                            <IonLabel>
                            Telephone:  <NumberFormat value={user.workPhone || user.cellPhone} displayType={'text'} format="(###) ###-####" />
                            </IonLabel>
                            )
                          }
                      else if(user.workPhone == null){
                            return ( 
                              <IonLabel>
                              Telephone:  <NumberFormat value={user.homePhone || user.cellPhone} displayType={'text'} format="(###) ###-####" />
                              </IonLabel>
                              )
                            }
                    })()} 

                    {(() => {
                      if((user.cellPhone === null || user.cellPhone == '') && (user.homePhone == null || user.homePhone == '') && (user.workPhone == null || user.workPhone == '')){
                        return ( 
                          <IonLabel>
                            <IonLabel>N/A</IonLabel>
                          </IonLabel>
                          )
                        }
                      })()}  
                  </IonLabel>
                </IonCol>

                <IonCol size="4">
                  <IonLabel className="ion-text-wrap">
                    Location: {user.propertyLocation}
                  </IonLabel>
                </IonCol>

                <IonCol size="4">
                  <IonLabel className="ion-text-wrap">
                    Zip code: {user.propertyZip}
                  </IonLabel>
                </IonCol>
              </IonRow>

              <IonRow>
              <IonCol size="4">
                  Survey Scheduled Date: {moment(user.surveyScheduledDate).format('MM/DD/YYYY')}
                </IonCol>
          
              <IonCol size="4">
                  <IonLabel className="ion-text-wrap">
                    City: {user.propertyCity}
                  </IonLabel>
              </IonCol>

              <IonCol size="4">
                   <button type="button" className="ion-button" onClick={() => {gotoSiteSurveyPage(user)}}>Site Survey</button>
                   <IonIcon className="ion-gps" icon={locate} onClick={() => naviagteToMap(user.propertyLocation +' '+user.propertyCity)}/>
                   {(() => {
                    if(user.notified == "No"){
                      return ( 
                        <IonCol>
                        <button type="button" className="ion-button" onClick={() => NotifyButton(user.id)}>Notify</button>
                        </IonCol>
                        )
                      }
                    })()} 
              </IonCol>
              </IonRow>
              
              </IonCardContent>
              : null}

{props.location.search == '?selection=pumpoutschedule' ?
              <IonCardContent className="card_content">
              <IonRow>
              <IonCol size="4">
              <IonLabel className="ion-text-wrap">Pumpout Scheduled Date: {moment(user.pumpoutDate).format('MM/DD/YYYY')} </IonLabel>
                </IonCol>

                <IonCol size="4">
                  Municipality: {user.municipalityName}
                </IonCol>

                <IonCol size="4">
                  {(() => {
                    if((user.s1FirstTankType != null && user.s1FirstTankType.includes('Aerobic')) || (user.s1SecondTankType != null && user.s1SecondTankType.includes('Aerobic')) || (user.s2FirstTankType != null && user.s2FirstTankType.includes('Aerobic'))
                    || (user.s2SecondTankType != null && user.s2SecondTankType.includes('Aerobic'))){
                      return ( 
                        <IonLabel>
                        System Type: ATU
                        </IonLabel>
                        )
                      } else if((user.s1FirstTankType != null && (user.s1FirstTankType.includes('1 Compartment') || user.s1FirstTankType.includes('2 Compartment'))) || (user.s1SecondTankType != null && (user.s1SecondTankType.includes('1 Compartment') || user.s1SecondTankType.includes('2 Compartment')))
                          || (user.s2FirstTankType != null && (user.s2FirstTankType.includes('1 Compartment') || user.s2FirstTankType.includes('2 Compartment'))) || (user.s2SecondTankType != null && (user.s2SecondTankType.includes('1 Compartment') || user.s2SecondTankType.includes('2 Compartment')))){
                        return ( 
                          <IonLabel>
                          System Type: Conventional
                          </IonLabel>
                          )
                        } else {
                        return ( 
                          <IonLabel>
                         System Type: N/A
                          </IonLabel>
                          )
                      }
                    })()} 
                </IonCol>

                </IonRow>

                <IonRow>
                   <IonCol size="4">
                  <IonLabel className="ion-text-wrap">
                    Customer Name: {user.ownersName}
                  </IonLabel>
                </IonCol>

                <IonCol size="4">
                  <IonLabel className="ion-text-wrap">
                    Location: {user.propertyLocation}
                  </IonLabel>
                </IonCol>

                <IonCol size="4">
                      {(() => {
                        if((user.s1FirstTankType != null && user.s1FirstTankType.includes('1 Compartment')) || (user.s1SecondTankType != null && user.s1SecondTankType.includes('2 Compartment'))){
                          return (
                            <IonLabel className="ion-text-wrap">
                              Tank Size: {user.septicTankSize} </IonLabel>
                          )
                        } else if((user.s1FirstTankType != null && user.s1FirstTankType.includes('2 Compartment')) || (user.s1SecondTankType != null && user.s1SecondTankType.includes('1 Compartment'))){
                          return (
                            <IonLabel className="ion-text-wrap">
                              Tank Size: {user.septicTankSize} </IonLabel>
                          )
                        } else if ((user.s2FirstTankType != null && user.s2FirstTankType.includes('1 Compartment')) || (user.s2SecondTankType != null && user.s2SecondTankType.includes('2 Compartment'))) {
                          return (
                            <IonLabel className="ion-text-wrap">
                              Tank Size: {user.septicTankSize} </IonLabel>
                          )
                        } else if ((user.s2FirstTankType != null && user.s2FirstTankType.includes('2 Compartment')) || (user.s2SecondTankType != null && user.s2SecondTankType.includes('1 Compartment'))) {
                          return (
                            <IonLabel className="ion-text-wrap">
                              Tank Size: {user.septicTankSize} </IonLabel>
                          )
                        } else if(((user.s1FirstTankType != null && user.s1FirstTankType == 'Aerobic') || (user.s1SecondTankType != null && user.s1SecondTankType == 'Aerobic')) && user.manufacturer == 'Hoot') {
                          return (
                            <IonLabel className="ion-text-wrap">
                            Tank Size: {user.manufacturer + ' ' + user.model} </IonLabel>
                          )
                        } else if(((user.s2FirstTankType != null && user.s2FirstTankType == 'Aerobic') || (user.s2SecondTankType != null && user.s2SecondTankType == 'Aerobic')) && user.manufacturer == 'Hoot') {
                          return (
                            <IonLabel className="ion-text-wrap">
                            Tank Size: {user.manufacturer + ' ' + user.model} </IonLabel>
                          )
                        } else if(((user.s1FirstTankType != null && user.s1FirstTankType == 'Aerobic') || (user.s1SecondTankType != null && user.s1SecondTankType == 'Aerobic')) && user.manufacturer != 'Hoot') {
                          return (
                            <IonLabel className="ion-text-wrap">
                            Tank Size: {user.manufacturer} </IonLabel>
                          )
                        } else if(((user.s2FirstTankType != null && user.s2FirstTankType == 'Aerobic') || (user.s2SecondTankType != null && user.s2SecondTankType == 'Aerobic')) && user.manufacturer != 'Hoot') {
                          return (
                            <IonLabel className="ion-text-wrap">
                            Tank Size: {user.manufacturer} </IonLabel>
                          )
                        } else if(user.septicTankSize != null) {
                          return (
                            <IonLabel className="ion-text-wrap">
                            Tank Size: {user.septicTankSize} </IonLabel>
                          )
                        } else if(user.septicTankSize == null){
                          return (
                            <IonLabel className="ion-text-wrap">
                              Tank Size: N/A </IonLabel>
                          )
                        }
                      })()}
                    </IonCol>
              </IonRow>

              <IonRow>
                 <IonCol size="4">
                  <IonLabel className="ion-text-wrap">
                  {(() => {
                    if(user.cellPhone != null){
                      return ( 
                        <IonLabel>
                        Telephone:  <NumberFormat value={user.cellPhone} displayType={'text'} format="(###) ###-####" />
                        </IonLabel>
                        )
                      }
                      else if(user.cellPhone == null){
                        return ( 
                          <IonLabel>
                          Telephone:  <NumberFormat value={user.workPhone || user.homePhone} displayType={'text'} format="(###) ###-####" />
                          </IonLabel>
                          )
                        }
                      else if(user.homePhone == null){
                          return ( 
                            <IonLabel>
                            Telephone:  <NumberFormat value={user.workPhone || user.cellPhone} displayType={'text'} format="(###) ###-####" />
                            </IonLabel>
                            )
                          }
                      else if(user.workPhone == null){
                            return ( 
                              <IonLabel>
                              Telephone:  <NumberFormat value={user.homePhone || user.cellPhone} displayType={'text'} format="(###) ###-####" />
                              </IonLabel>
                              )
                            }
                    })()} 

                    {(() => {
                      if((user.cellPhone === null || user.cellPhone == '') && (user.homePhone == null || user.homePhone == '') && (user.workPhone == null || user.workPhone == '')){
                        return ( 
                          <IonLabel>
                            <IonLabel>N/A</IonLabel>
                          </IonLabel>
                          )
                        }
                      })()}  
                  </IonLabel>
                </IonCol>

                    <IonCol size="4">
                      <IonLabel className="ion-text-wrap">
                        ZipCode: {user.propertyZip}
                      </IonLabel>
                    </IonCol>

                    <IonCol>
                {(() => {
                        if (user.s1FirstTankType != null && user.s1SecondTankType != null && user.s2FirstTankType != null && user.s2SecondTankType != null) {
                          return (
                            <IonLabel className="ion-text-wrap">
                              Tank Type: {user.s1FirstTankType + '/' + user.s1SecondTankType + '/' + user.s2FirstTankType + '/' + user.s2SecondTankType} </IonLabel>
                          )
                        } 
                        if (user.s1FirstTankType != null && user.s1SecondTankType != null && user.s2FirstTankType != null) {
                          return (
                            <IonLabel className="ion-text-wrap">
                              Tank Type: {user.s1FirstTankType + '/' + user.s1SecondTankType + '/' + user.s2FirstTankType} </IonLabel>
                          )
                        }
                        if (user.s1FirstTankType != null && user.s1SecondTankType != null) {
                          return (
                            <IonLabel className="ion-text-wrap">
                              Tank Type: {user.s1FirstTankType + '/' + user.s1SecondTankType} </IonLabel>
                          )
                        } if (user.s1FirstTankType != null && user.s2FirstTankType != null) {
                          return (
                            <IonLabel className="ion-text-wrap">
                              Tank Type: {user.s1FirstTankType + '/' + user.s2FirstTankType} </IonLabel>
                          )
                        } if (user.s1FirstTankType != null) {
                          return (
                            <IonLabel className="ion-text-wrap">
                              Tank Type: {user.s1FirstTankType} </IonLabel>
                          )
                        } if (user.s1SecondTankType != null) {
                          return (
                            <IonLabel className="ion-text-wrap">
                              Tank Type: {user.s1SecondTankType} </IonLabel>
                          )
                        } else {
                          return (
                            <IonLabel className="ion-text-wrap">Tank Type: N/A </IonLabel>
                          )
                        }
                      })()}  
              </IonCol>
              </IonRow>

              <IonRow>
             <IonCol size="4">
              {(() => {
                      if(user.pumpOutType != null) {
                        return (
                            <IonLabel className="ion-text-wrap">
                              Pumpout Type: {user.pumpOutType} </IonLabel>
                          )
                        } else if(user.pumpOutType == null || user.pumpOutType == '') {
                          return ( 
                              <IonLabel className="ion-text-wrap">
                               Pumpout Type: N/A </IonLabel>
                            )
                        }
                      })()}  
            </IonCol>
				
				    <IonCol size="4">
                  <IonLabel className="ion-text-wrap">
                    City: {user.propertyCity}
                  </IonLabel>
              </IonCol>

               <IonCol>
                  <IonLabel className="ion-text-wrap">
                    Tank Location: {user.infoTrtmtTank}
                  </IonLabel>
              </IonCol>
          </IonRow>

                <IonRow>
                <IonCol size="4">
                {(() => {
                      if(user.typeOfCustomer == 'Pumpout Customer') {
                        return (
                            <IonLabel className="ion-text-wrap">
                            Type of Customer: {user.typeOfCustomer.replace('Pumpout Customer','Repeat Non Sp Customer')} </IonLabel>
                          )
                        } else if(user.typeOfCustomer == '' || user.typeOfCustomer == null) {
                          return ( 
                              <IonLabel className="ion-text-wrap">
                             Type of Customer: N/A </IonLabel>
                            )
                        } else {
                          return (
                            <IonLabel className="ion-text-wrap">
                            Type of Customer: {user.typeOfCustomer}
                            </IonLabel>
                          )
                        }
                      })()}  
              </IonCol>
                      
              <IonCol size="4">
                {(() => {
                      if(user.bestLocToParkPumpTruck != null) {
                        return (
                            <IonLabel className="ion-text-wrap">
                              Where to Park: {user.bestLocToParkPumpTruck} </IonLabel>
                          )
                        } else if(user.bestLocToParkPumpTruck == null || user.bestLocToParkPumpTruck == '') {
                          return ( 
                              <IonLabel className="ion-text-wrap">
                               Where to Park: N/A </IonLabel>
                            )
                        }
                      })()}  
                 </IonCol>

                 <IonCol>
                 {(() => {
                        if(user.pumpoutTime != null && user.pumpOutType == 'Inspection' && user.comments != null) {
                          return (
                              <IonLabel className="ion-text-wrap">
                                  Comments: {user.pumpoutTime + ', ' + user.comments} 
                              </IonLabel>
                            )
                          } 
                          if(user.pumpoutTime != null && user.pumpOutType == 'Inspection' && user.comments == null) {
                            return (
                                <IonLabel className="ion-text-wrap">
                                    Comments: {user.pumpoutTime} 
                                </IonLabel>
                              )
                          } else {
                            return (
                              <IonLabel className="ion-text-wrap">
                                Comments: {user.comments}
                              </IonLabel>
                            )
                          }
                      })()}  
              </IonCol>
              </IonRow>

              <IonRow>
                <IonCol size="4">
              </IonCol>
                      
              <IonCol size="4">
                 </IonCol>

                 <IonCol size = "4">
                   <button type="button" className="ion-button" onClick={() => {gotoPumpOutPage(user)}}>Pumpout</button>
                   <IonIcon className="ion-gps" icon={locate} onClick={() => naviagteToMap(user.propertyLocation +' '+user.propertyCity)}/>
                   {(() => {
                    if(user.notified == "No"){
                      return ( 
                        <IonCol>
                        <button type="button" className="ion-button" onClick={() => NotifyButton(user.id)}>Notify</button>
                        </IonCol>
                        )
                      }
                    })()} 
              </IonCol>
              </IonRow>
              
              </IonCardContent>
              : null}
            </IonCard>
          ))}

     
        </>
      </IonContent>
      

    </IonPage>
    </SchedulePage>
  );
};

const SchedulePage = styled(IonPage)`
ion-content{
  --ion-background-color:#cef2d0;
  
}

.ion-button{
  padding: 8px;
  background-color: #019849;
  color:#ffffff;
  border-radius: 4px;
}

.ion-gps{
  font-size: 25px;
  cursor: pointer;
    margin-left: 10px;
    position: relative;
    top: 8px;
    background-color: #f2f2f2 ;
    padding: 1px;
    box-shadow: 1px 1px 2px grey;
    border-radius: 4px;
}

.card_content{
  margin-top: 0;
  padding: 6px;
  bottom: 2px;
  color : #006884;
  background-color: #ffffff;
}
.btn_ins{
  padding: 8px;
  background-color: #019849;
  color: #fff;
}
.modal-wrapper{
  height: 50%!important;
    width: 50%!important;
}
`;


export default UpcomingShedulePage;
